import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { cleanUpLegacyInstall } from "./app/legacyCleanup";
import "./styles/fonts";
import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/app.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("No se encontro el elemento #root");
}

void cleanUpLegacyInstall();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
